var _a;
import { IdAssetBundleBalancing } from "./IdAssetBundleBalancing";
export var initialStateBalancing = (_a = {},
    _a[IdAssetBundleBalancing.Constants] = {},
    _a[IdAssetBundleBalancing.CoopLevels] = new Map(),
    _a[IdAssetBundleBalancing.CoopSettings] = new Map(),
    _a[IdAssetBundleBalancing.CoopProjects] = new Map(),
    _a[IdAssetBundleBalancing.Farms] = [],
    _a[IdAssetBundleBalancing.Expansions] = [],
    _a[IdAssetBundleBalancing.Buildings] = new Map(),
    _a[IdAssetBundleBalancing.Resources] = new Map(),
    _a[IdAssetBundleBalancing.Quests] = new Map(),
    _a[IdAssetBundleBalancing.QuestIntros] = new Map(),
    _a[IdAssetBundleBalancing.Recipes] = new Map(),
    _a[IdAssetBundleBalancing.PlayerLevels] = new Map(),
    _a[IdAssetBundleBalancing.UiDefinitions] = new Map(),
    _a[IdAssetBundleBalancing.ContractOrders] = new Map(),
    _a[IdAssetBundleBalancing.ContractRewards] = new Map(),
    _a[IdAssetBundleBalancing.Characters] = new Map(),
    _a[IdAssetBundleBalancing.Outskirts] = new Map(),
    _a[IdAssetBundleBalancing.FarmEvents] = new Map(),
    _a[IdAssetBundleBalancing.ProfilePictures] = new Map(),
    _a[IdAssetBundleBalancing.PurchaseOfferGroups] = new Map(),
    _a[IdAssetBundleBalancing.PurchaseOfferShiftLevels] = new Map(),
    _a[IdAssetBundleBalancing.RandomPools] = new Map(),
    _a[IdAssetBundleBalancing.Packages] = new Map(),
    _a[IdAssetBundleBalancing.LanguageSettings] = [],
    _a[IdAssetBundleBalancing.LibraryImprovements] = new Map(),
    _a[IdAssetBundleBalancing.MarketImprovements] = new Map(),
    _a[IdAssetBundleBalancing.Buffs] = new Map(),
    _a[IdAssetBundleBalancing.BalloonOfferContents] = new Map(),
    _a[IdAssetBundleBalancing.BalloonOfferTypes] = new Map(),
    _a[IdAssetBundleBalancing.PVPMapDefinitions] = [],
    _a);



//////////////////
// WEBPACK FOOTER
// ./src/features/balancing/IBalancing.ts
// module id = 1145
// module chunks = 3